// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"74":"3dc33e6b","444":"6f19d03b","480":"5685491e","880":"784d9762"}[chunkId] + ".js";
};